import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TeaserComponent} from './elements/teaser/teaser.component';
import {UiModule} from '@kion/ui';
import {ProductCardComponent} from './elements/product-card/product-card.component';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {ProductSliderComponent} from './elements/product-slider/product-slider.component';
import {SupportBannerComponent} from './elements/support-banner/support-banner.component';
import {TranslateModule} from '@ngx-translate/core';
import {ProductDetailComponent} from './elements/product-detail/product-detail.component';
import {VariantSelectionComponent} from './elements/product-detail/variant-selection/variant-selection.component';
import {ProductImageCarouselComponent} from './elements/product-detail/product-carousel/product-image-carousel/product-image-carousel.component';
import {TechnicalDataComponent} from './elements/product-detail/technical-data/technical-data.component';
import {BenefitDataComponent} from './elements/product-detail/benefit-data/benefit-data.component';
import {ProductInformationComponent} from './elements/product-detail/product-information/product-information.component';
import {DownloadsComponent} from './elements/product-detail/downloads/downloads.component';
import {MarkdownModule} from 'ngx-markdown';
import {ProductCarouselComponent} from './elements/product-detail/product-carousel/product-carousel.component';
import {PreviewImageComponent} from './elements/product-detail/product-carousel/preview-image/preview-image.component';
import {ReactiveFormsModule} from '@angular/forms';
import {HeaderButtonsComponent} from './elements/header-buttons/header-buttons.component';
import {MiniBasketComponent} from './elements/header-buttons/mini-basket/mini-basket.component';
import {BasketListComponent} from './elements/basket-list/basket-list.component';
import {BasketListItemComponent} from './elements/basket-list/basket-list-item/basket-list-item.component';
import {BasketSummaryComponent} from './elements/basket-summary/basket-summary.component';
import {CheckoutHeaderComponent} from './elements/checkout-header/checkout-header.component';
import {PaymentItemComponent} from './elements/payment-item/payment-item.component';
import {ContactBoxComponent} from './elements/contact-box/contact-box.component';
import {InfoComponent} from './elements/info/info.component';
import {FilterBarComponent} from './elements/filter-bar/filter-bar.component';
import {FilterListItemComponent} from './elements/filter-bar/filter-list-item/filter-list-item.component';
import {SearchBoxComponent} from './elements/search-box/search-box.component';
import {CookieConsentDialogComponent} from './dialogs/cookie-consent-dialog/cookie-consent-dialog.component';
import {VariantSelectionItemComponent} from './elements/product-detail/variant-selection/variant-selection-item/variant-selection-item.component';
import {SwiperModule} from 'swiper/angular';
import {GeoLocationBannerComponent} from './elements/geo-location-banner/geo-location-banner.component';
import {CategoryNavigationComponent} from './elements/category-navigation/category-navigation.component';
import {PriceOnRequestDialogComponent} from './dialogs/price-on-request-dialog/price-on-request-dialog.component';
import {DeliveryDateConversionPipe} from "./pipes/delivery-date-conversion.pipe";
import { DeliveryTimeComponent } from './elements/product-detail/delivery-time/delivery-time.component';
import { NetworkPartnerChooseDialogComponent } from './dialogs/network-partner-choose-dialog/network-partner-choose-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    LazyLoadImageModule,
    TranslateModule,
    MarkdownModule,
    ReactiveFormsModule,
    SwiperModule,
    UiModule,
  ],
  declarations: [
    TeaserComponent,
    ProductCardComponent,
    ProductSliderComponent,
    SupportBannerComponent,
    ProductDetailComponent,
    VariantSelectionComponent,
    ProductImageCarouselComponent,
    TechnicalDataComponent,
    BenefitDataComponent,
    ProductInformationComponent,
    DownloadsComponent,
    ProductCarouselComponent,
    PreviewImageComponent,
    HeaderButtonsComponent,
    MiniBasketComponent,
    BasketListComponent,
    BasketListItemComponent,
    BasketSummaryComponent,
    CheckoutHeaderComponent,
    PaymentItemComponent,
    ContactBoxComponent,
    InfoComponent,
    FilterBarComponent,
    FilterListItemComponent,
    SearchBoxComponent,
    CookieConsentDialogComponent,
    VariantSelectionItemComponent,
    GeoLocationBannerComponent,
    CategoryNavigationComponent,
    PriceOnRequestDialogComponent,
    DeliveryDateConversionPipe,
    DeliveryTimeComponent,
    NetworkPartnerChooseDialogComponent
  ],
  exports: [
    TeaserComponent,
    ProductCardComponent,
    ProductSliderComponent,
    SupportBannerComponent,
    ProductDetailComponent,
    HeaderButtonsComponent,
    BasketListComponent,
    BasketSummaryComponent,
    CheckoutHeaderComponent,
    PaymentItemComponent,
    ContactBoxComponent,
    InfoComponent,
    FilterBarComponent,
    SearchBoxComponent,
    GeoLocationBannerComponent,
    CategoryNavigationComponent
  ]
})
export class LrUiModule {
  constructor() {}
}
